<template>
  <div class="relative right-0 h-full flex items-center justify-center bg-gray-100">
    <div class="text-center p-8">
      <h2 class="text-2xl font-bold mb-4">GitHub</h2>
      <p class="mb-6">Opening GitHub profile...</p>
      <a 
        :href="githubUrl" 
        target="_blank" 
        rel="noopener noreferrer"
        class="inline-block px-6 py-3 bg-gray-800 text-white rounded hover:bg-gray-900 transition-colors"
      >
        Open GitHub Profile
      </a>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const githubUrl = 'https://github.com/sobhanizd'

onMounted(() => {
  // Automatically open GitHub in a new tab
  window.open(githubUrl, '_blank', 'noopener,noreferrer')
})
</script>

